import ClickFunnelsDrawer from './ClickFunnelsDrawer';

const drawers = [ClickFunnelsDrawer];

export default drawers;
